import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Images from "../../../assets";
import { formatDate, setWordCase } from "../../../assets/library";

const WorkExperiences = (props: any) => {
  return (
    <div>
      <Typography
        sx={{
          background: "#FCF1EE",
          width: "fit-content",
          p: 1,
          borderRadius: "10px",
          mb: 2,
        }}
      >
        Work Experience
      </Typography>
      {props.data?.length > 0
        ? props.data.map((item:any, i:number) => (
            <Grid
              container
              sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}
              key={i}
            >
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Name of Organization
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{setWordCase(item.companyName)}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Designation
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.designation}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Work Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{setWordCase(item.type)}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Started From
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.startDate ? formatDate(item.startDate,true):""}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        minWidth: 150,
                        color: "#7C7A7A",
                        fontSize: "14px",
                      }}
                    >
                      Completed on
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{item.endDate ? formatDate(item?.endDate,true):"Ongoing"}</Typography>
                  </Grid>
                </Grid>
              </Grid>
             
            </Grid>
          ))
        : 
        <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              flexDirection: "column",
            }}
          >
            <img
              src={Images.noData}
              alt="noData"
              style={{ width: "70px", height: "70px", marginBottom: "1rem" }}
            />
            <Typography>No data </Typography>
          </Box>}
    </div>
  );
};

export default WorkExperiences;
